import { Dispatch, SetStateAction } from "react";
import Icon from "../../common/Icon";
import styles from "./SideSheetHandle.module.css";

interface HandleProps {
    showSideSheet?: boolean;
    setShowSideSheet?: Dispatch<SetStateAction<boolean>> | undefined;
    showFloatingSheet?: boolean;
    setShowFloatingSheet?: Dispatch<SetStateAction<boolean>> | undefined;
    shouldSideRender?: boolean;
    selectedPoiIdx?: number | string;

    isClosedSideSheet?: boolean;
    setIsClosedSideSheet?: Dispatch<SetStateAction<boolean>>;
}

/**
 * @author cwlee
 * @date 2024-09-03 10:53:11
 * @remark 사이드 시트 폴드 핸들
 * @returns
 */
const SideSheetHandle = (props: HandleProps) => {
    const showAndHide = () => {
        if (props.showFloatingSheet) {
            props.setShowFloatingSheet && props.setShowFloatingSheet(!props.showSideSheet);
            setTimeout(() => {
                props.setShowSideSheet && props.setShowSideSheet(!props.showSideSheet);
                
                // 25.07.17 | Kim Young Jun | 사이드 시트 닫힘 상태 추가
                console.log("showAndHide props.showFloatingSheet > props.isClosedSideSheet: ", props.isClosedSideSheet);
                props.setIsClosedSideSheet && props.setIsClosedSideSheet(!props.isClosedSideSheet);
            }, 250);
        } else {
            // 25.07.17 | Kim Young Jun | 사이드 시트 닫힘 상태 추가
            if(props.showSideSheet){
                props.setIsClosedSideSheet && props.setIsClosedSideSheet(true);
            }

            props.setShowSideSheet && props.setShowSideSheet(!props.showSideSheet);
            
            console.log("showAndHide props.selectedPoiIdx: ", props.selectedPoiIdx);
            // 25.07.17 | Kim Young Jun | 선택된 아이템이 있고 닫혔다가 열리는 경우 showFloatingSheet 동작 하도록
            if(props.selectedPoiIdx !== 0){
                setTimeout(() => {
                    console.log("showAndHide props.showFloatingSheet: ", props.showFloatingSheet);
                    props.setShowFloatingSheet && props.setShowFloatingSheet(!props.showFloatingSheet);
                }, 400);
            }
        }
    };

    return (
        <div className={`${styles.default} ${props.showSideSheet ? "" : styles.hide} ${props.shouldSideRender ? styles.is_sheet : ''}`}>
            <div className={`${styles["handle"]}`} onClick={showAndHide}>
                {props.showSideSheet ? <Icon name="arrow_back" /> : <Icon name="arrow_play" />}
            </div>
        </div>
    );
};

export default SideSheetHandle;
